import { j as m } from "./jsx-runtime-DmTjM30f.mjs";
import { useState as p, useCallback as h, useMemo as z } from "react";
import { c as C } from "./tw-cn-mXgPecoF.mjs";
import { a as b } from "./radio-button-2Msn3K2H.mjs";
const y = (o) => {
  const {
    id: n,
    name: s,
    className: c,
    children: d,
    value: f,
    defaultValue: v,
    disabled: t,
    size: l,
    style: x,
    onChange: e
  } = o, [a, R] = p(f ?? v), i = h(
    (u) => {
      const j = a, r = u.target.value;
      "value" in o || R(r), r !== j && (e == null || e(u));
    },
    [a, o, e]
  ), V = z(
    () => ({ onChange: i, value: a, disabled: t, name: s, size: l }),
    [i, a, t, s, l]
  );
  return /* @__PURE__ */ m.jsx("div", { className: C(c), id: n, style: x, children: /* @__PURE__ */ m.jsx(b, { value: V, children: d }) });
};
export {
  y as R
};
